<template>
  <div class="credit-page">
    <div v-if="pending"
         style="min-height: 20rem; position: relative">
      <BasePreloader/>
    </div>
    <div v-else-if="error"
         class="container">
      <ErrorView :code="error.code"
                 :title="error.message"
                 class="container-inner"/>
    </div>
    <template v-else-if="pageData">
      <CreditPageFirstSection :section="pageData.additional.promo_block"/>
      <CreditsPageAdvantages :section="pageData.additional.our_advantages"/>
      <CreditsPageGetCredit :section="pageData.additional.text_block"/>
      <CreditsPageHowItWork :section="pageData.additional.how_it_works"/>
      <HomePageReviews :reviews="pageData.reviews.data">
        <template v-slot:btn>
          <CreditsPageAdvantagesBtn class="reviews__btn"/>
        </template>
      </HomePageReviews>
      <CreditsPageFAQ v-if="pageData.faq && pageData.faq.length"
                      :section="pageData.faq"/>
      <CreditsPageText :title="pageData.body_title"
                       :body="pageData.body"/>
    </template>
  </div>
</template>

<script>
  import {http} from '@/axios'
  import globalMetaMixin from '@/mixins/globalMetaMixin'
  import defer from '@/mixins/defer'
  import ErrorView from '@/components/ErrorView'
  import CreditPageFirstSection from '@/components/creditsPage/CreditsPageFirstSection'
  import CreditsPageAdvantages from '@/components/creditsPage/CreditsPageAdvantages'
  import CreditsPageGetCredit from '@/components/creditsPage/CreditsPageGetCredit'
  import CreditsPageHowItWork from '@/components/creditsPage/CreditsPageHowItWork'
  import HomePageReviews from '@/components/homePage/HomePageReviews'
  import CreditsPageFAQ from '@/components/creditsPage/CreditsPageFAQ'
  import CreditsPageText from '@/components/creditsPage/CreditsPageText'
  import CreditsPageAdvantagesBtn from '@/components/creditsPage/common/CreditsPageAdvantagesBtn'

  export default {
    name: 'CreditsPage',
    mixins: [globalMetaMixin, defer()],
    components: {
      ErrorView,
      CreditPageFirstSection,
      CreditsPageAdvantages,
      CreditsPageGetCredit,
      CreditsPageHowItWork,
      HomePageReviews,
      CreditsPageFAQ,
      CreditsPageText,
      CreditsPageAdvantagesBtn,
    },
    data() {
      return {
        error: null,
        pending: false,
        pageData: null,
      }
    },
    methods: {
      load() {
        this.pending = true

        return http.get('/api/services/microcredit').then(({data}) => {
          this.pageData = data.data

          const meta = data.data

          if (meta.meta_title) {
            this.setMetaTitleMixin(meta.meta_title)
          }

          if (meta.meta_description) {
            this.setMetaDescriptionMixin(meta.meta_description)
          }

          if (meta.meta_keywords) {
            this.setMetaKeywords(meta.meta_keywords)
          }

          this.setOpenGraph({
            title: meta.meta_title && this.setMetaTitleMixin(meta.meta_title),
            description: meta.meta_description && this.setMetaDescriptionMixin(meta.meta_description),
          })

          this.runDisplayPriority()
        }).finally(() => {
          this.pending = false
        })
      },
    },
    created() {
      this.load()
    },
  }
</script>

<style lang="less">

</style>
